import ProtectedRoute from "../panel/routes/ProtectedRoute";

import AdministratorsRoute from "../panel/routes/administrator.route";
import GovernmentShipRoute from "../panel/routes/governmentShip.route";
import ProvinceEducationRoute from "../panel/routes/provinceEducation.route";
import SuperAgentRoute from "../panel/routes/superAgent.route";
import CompanyRoute from "../panel/routes/company.route";

import {Navigate, Route, Routes} from "react-router-dom";
import {LoginScreen, NotFound} from "../panel/screen";
import LoginAdminScreen from "../panel/screen/LoginAdminScreen";
import MunicipalityRoute from "../panel/routes/municipality.route";
import RegisterScreen from "../panel/screen/RegisterScreen";
import WebsiteScreen from "../website/routes";

const Navigation = () => {
  return (
    <Routes>
      <Route path="/panel/" element={<Navigate to={"panel/login"} />} />
      <Route path="/panel/administrator/*" element={<ProtectedRoute Component={<AdministratorsRoute />} />} />
      <Route path="/panel/government-ship/*" element={<ProtectedRoute Component={<GovernmentShipRoute />} />} />
      <Route path="/panel/province-education/*" element={<ProtectedRoute Component={<ProvinceEducationRoute />} />} />
      <Route path="/panel/super-agent/*" element={<ProtectedRoute Component={<SuperAgentRoute />} />} />
      <Route path="/panel/company/*" element={<ProtectedRoute Component={<CompanyRoute />} />} />{" "}
      <Route path="/panel/municipality/*" element={<ProtectedRoute Component={<MunicipalityRoute />} />} />
      <Route path="/panel/login" element={<LoginScreen />} />
      <Route path="/panel/register" element={<RegisterScreen />} />
      <Route path="/panel/login-admin/*" element={<LoginAdminScreen />} />
      <Route path="/panel/*" element={<NotFound />} />
      <Route path="/*" element={<WebsiteScreen />} />
    </Routes>
  );
};

export default Navigation;
